<template>
    <div class="flex flex-col">
        <page-header>
            Campaigns

            <template v-if="!props.withoutOverview" v-slot:actions>
                <vx-button
                    @click="showOverview = !showOverview"
                    data-test="toggle-overview"
                    type="button"
                    color="muted-dark"
                    size="lg"
                >
                    <span class="hidden sm:inline-block"
                        >{{ showOverview ? "Hide" : "Show" }} Overview</span
                    >
                    <font-awesome-icon widthAuto
                        class="hidden sm:inline-block"
                        :icon="faCircleQuestion"
                    ></font-awesome-icon>
                    <font-awesome-icon widthAuto
                        class="inline-block! sm:hidden!"
                        :icon="
                            showOverview
                                ? faCircleChevronUp
                                : faCircleChevronDown
                        "
                    ></font-awesome-icon>
                </vx-button>
            </template>
        </page-header>

        <campaign-overview v-show="showOverview" class="mb-14"/>
    </div>
</template>
<script setup>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
    faCircleChevronDown,
    faCircleChevronUp,
    faCircleQuestion,
} from "@fortawesome/pro-solid-svg-icons";
import { VxButton } from '@voxie/frontend-components';
import { ref } from "vue";
import PageHeader from "~/components/general/PageHeader.vue";
import CampaignOverview from "./CampaignOverview.vue";

const props = defineProps({
    withoutOverview: {
        type: Boolean,
        default: false,
    },
});

const showOverview = ref(false);
</script>
